// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application } from './application'
import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.globEager('./**/*_controller.js')
registerControllers(application, controllers)
